// extracted by mini-css-extract-plugin
export default {"contents":"AK-z","sectionHeading":"BK-z"};